import React from 'react'
import classNames from 'classnames'

import classes from './PageSection.scss';
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography';

type PageSectionProps = React.PropsWithChildren<{
  className?: string
  title?: string
  leftColor?: string
  leftImage?: string
  rightColor?: string
  rightImage?: string
  textClassName?: string
}>

export default function PageSection({
  className,
  title,
  leftColor,
  leftImage,
  rightColor,
  rightImage,
  children,
}: PageSectionProps): JSX.Element {

  const hasLeft = leftColor || leftImage;
  const hasRight = rightColor || rightImage;

  return (
    <section className={classNames(className, { [classes.sectionWithLeft]: hasLeft, [classes.sectionWithRight]: hasRight })}>
      {hasLeft && (
        <div className={classes.image} style={{ backgroundColor: leftColor, backgroundImage: `url(${leftImage})` }} />
      )}

      <Paper className={classes.text} square elevation={0}>
        {title && (
          <Typography component="h2" className={classes.header}>{title}</Typography>
        )}
        <div className={classes.content}>
          {children}
        </div>
      </Paper>

      {hasRight && (
        <div className={classes.image} style={{ backgroundColor: rightColor, backgroundImage: `url(${rightImage})` }} />
      )}
    </section>
  );
}
